<template>
<v-autocomplete
  v-model="select"
  :items="items"
  :loading="loading"
  :search-input.sync="search"
  hide-no-data
  no-filter
  return-object

  :menu-props="{ offsetY: true, fixed: true }"
  :label="$t('Standort')"
  :placeholder="placeholder"

  no-data-text="Keine passenden Orte gefunden"
  attach
  @change="change"
  filled
></v-autocomplete>
</template>

<script>
import { GeocoderFactory } from "./Geocoder";

export default {
  name: "GeocoderAutocomplete",

  props: [
    "value",
    "placeholder"
  ],

  data() {
    return {
      loading: false,
      search: null,
      select: null,
      items: [],
      queryGeneration: 0,
      searchTimeout: null,
      isDisposed: false
    };
  },

  created() {
    GeocoderFactory().then(geocoder => {
      if (this.isDisposed) {
        geocoder.destroy();
        return;
      }
      this.geocoder = geocoder;
    }).catch(() => {
      this.geocoder = null;
      this.loading = false;
    });
  },

  watch: {
    search(val) {
      if (typeof val !== "string" || !val.trim()) {
        this.cancelSearch();
      } else if (val !== this.selectedText()) {
        this.querySelections(val);
      }
    },

    value(val) {
      if (val) {
        this.select = val;
      }
    }
  },

  beforeDestroy() {
    this.isDisposed = true;
    this.cancelSearch();
    if (this.geocoder) {
      this.geocoder.destroy();
    }
  },

  methods: {
    selectedText() {
      return this.select && typeof this.select === "object" ? this.select.text : this.select;
    },

    cancelSearch(clearItems = true) {
      this.queryGeneration += 1;
      if (this.searchTimeout != null) {
        clearTimeout(this.searchTimeout);
        this.searchTimeout = null;
      }
      if (this.geocoder) {
        this.geocoder.cancelAutocomplete();
      }
      if (clearItems) {
        this.items = [];
      }
      this.loading = false;
    },

    querySelections(value) {
      this.cancelSearch();
      if (!this.geocoder) {
        return;
      }
      const generation = this.queryGeneration;
      this.loading = true;
      this.searchTimeout = setTimeout(() => {
        this.searchTimeout = null;
        this.geocoder.autocomplete(value).then(items => {
          if (generation === this.queryGeneration) {
            this.items = items;
          }
        }).catch(() => {
          if (generation === this.queryGeneration) {
            this.items = [];
          }
        }).finally(() => {
          if (generation === this.queryGeneration) {
            this.loading = false;
          }
        });
      }, 150);
    },

    change(o) {
      this.cancelSearch(false);
      this.$emit("change", o);
    }
  }
};
</script>
